import { supervisingAttorneySearchConfig } from "./config/counselSearchConfig";
import AttorneyLikeFieldset from "./components/AttorneyLikeFieldset";

const CounselSupervisingAttorneyFields = ({ entityId, statesData }) => (
  <AttorneyLikeFieldset
    entityId={entityId}
    prefix="supervisor_attorney"
    panelName="Supervising Attorney"
    dynamicLabel="Supervising Attorney Full Name"
    searchConfig={supervisingAttorneySearchConfig}
    statesData={statesData}
  />
);

export default CounselSupervisingAttorneyFields;
